<template>
  <div class="columns is-multiline">
    <div class="column is-one-quarter is-full-mobile">
      <window title="Add a new Event">
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Title</label>
          </div>
          <div class="field-body">
            <div class="control">
              <input v-model="newEventTitle" class="input" type="text">
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Start date</label>
          </div>
          <div class="field-body">
            <div class="control">
              <input v-model="newEventStartDate" class="input" type="date">
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">End date</label>
          </div>
          <div class="field-body">
            <div class="control">
              <input v-model="newEventEndDate" class="input" type="date">
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label"></div>
          <div class="field-body">
            <div class="control">
              <button class="button is-primary" @click="clickTestAddEvent">
                <span class="icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Add Event</span>
              </button>
            </div>
          </div>
        </div>
      </window>
    </div>
    <div class="column is-three-quarters is-full-mobile">
      <window title="Play with the options" height="100%">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Period UOM</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="displayPeriodUom">
                    <option>month</option>
                    <option>week</option>
                    <option>year</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Period Count</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="displayPeriodCount">
                    <option :value="1">1</option>
                    <option :value="2">2</option>
                    <option :value="3">3</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Starting day of the week</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="startingDayOfWeek">
                    <option v-for="(d, index) in dayNames" :value="index" :key="index">
                      {{ d }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Themes</label>
              <b-checkbox v-model="useDefaultTheme">Default</b-checkbox>
              <b-checkbox v-model="useHolidayTheme">Holidays</b-checkbox>
            </div>
          </div>
        </div>
      </window>
    </div>
    <div v-if="message" class="column is-full">
      <div class="notification is-success">{{ message }}</div>
    </div>
    <div class="column">
      <window title="Calendar">
        <div class="calendar-parent">
          <calendar-view :events="events" :show-date="showDate"
            :time-format-options="{hour: 'numeric', minute:'2-digit'}"
            :enable-drag-drop="true" :disable-past="disablePast" :disable-future="disableFuture"
            :show-event-times="showEventTimes" :display-period-uom="displayPeriodUom"
            :display-period-count="displayPeriodCount" :starting-day-of-week="startingDayOfWeek"
            :class="themeClasses" @drop-on-date="onDrop" @click-date="onClickDay"
            @click-event="onClickEvent" @show-date-change="setShowDate"
          />
        </div>
      </window>
    </div>
  </div>
</template>

<script>
import CalendarView from 'vue-simple-calendar';
import CalendarMathMixin from 'vue-simple-calendar/dist/calendar-math-mixin';

require('vue-simple-calendar/dist/static/css/default.css');
require('vue-simple-calendar/dist/static/css/holidays-us.css');
// For live testing while making changes to the component, assumes repo pulled to sister folder
/*
import CalendarView from "../../vue-simple-calendar/src/CalendarView.vue"
import CalendarMathMixin from "../../vue-simple-calendar/src/CalendarMathMixin.js"
require("../../vue-simple-calendar/static/css/default.css")
require("../../vue-simple-calendar/static/css/holidays-us.css")
*/
export default {
  name: 'App',
  components: {
    CalendarView,
  },
  mixins: [CalendarMathMixin],
  data() {
    return {
      /* Show the current month, and give it some fake events to show */
      showDate: this.thisMonth(1),
      message: '',
      startingDayOfWeek: 0,
      disablePast: false,
      disableFuture: false,
      displayPeriodUom: 'month',
      displayPeriodCount: 1,
      showEventTimes: true,
      newEventTitle: '',
      newEventStartDate: '',
      newEventEndDate: '',
      useDefaultTheme: true,
      useHolidayTheme: true,
      events: [
        {
          id: 'e0',
          startDate: '2018-01-05',
        },
        {
          id: 'e1',
          startDate: this.thisMonth(15, 18, 30),
        },
        {
          id: 'e2',
          startDate: this.thisMonth(15),
          title: 'Single-day event with a long title',
        },
        {
          id: 'e3',
          startDate: this.thisMonth(7, 9, 25),
          endDate: this.thisMonth(10, 16, 30),
          title: 'Multi-day event with a long title and times',
        },
        {
          id: 'e4',
          startDate: this.thisMonth(20),
          title: 'My Birthday!',
          classes: 'birthday',
          url: 'https://en.wikipedia.org/wiki/Birthday',
        },
        {
          id: 'e5',
          startDate: this.thisMonth(5),
          endDate: this.thisMonth(12),
          title: 'Multi-day event',
          classes: 'purple',
        },
        {
          id: 'foo',
          startDate: this.thisMonth(29),
          title: 'Same day 1',
        },
        {
          id: 'e6',
          startDate: this.thisMonth(29),
          title: 'Same day 2',
          classes: 'orange',
        },
        {
          id: 'e7',
          startDate: this.thisMonth(29),
          title: 'Same day 3',
        },
        {
          id: 'e8',
          startDate: this.thisMonth(29),
          title: 'Same day 4',
          classes: 'orange',
        },
        {
          id: 'e9',
          startDate: this.thisMonth(29),
          title: 'Same day 5',
        },
        {
          id: 'e10',
          startDate: this.thisMonth(29),
          title: 'Same day 6',
          classes: 'orange',
        },
        {
          id: 'e11',
          startDate: this.thisMonth(29),
          title: 'Same day 7',
        },
      ],
    };
  },
  computed: {
    userLocale() {
      return this.getDefaultBrowserLocale;
    },
    dayNames() {
      return this.getFormattedWeekdayNames(this.userLocale, 'long', 0);
    },
    themeClasses() {
      return {
        'theme-default': this.useDefaultTheme,
        'holiday-us-traditional': this.useHolidayTheme,
        'holiday-us-official': this.useHolidayTheme,
      };
    },
  },
  mounted() {
    this.newEventStartDate = this.isoYearMonthDay(this.today());
    this.newEventEndDate = this.isoYearMonthDay(this.today());
  },
  methods: {
    thisMonth(d, h, m) {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0);
    },
    onClickDay(d) {
      this.message = `You clicked: ${d.toLocaleDateString()}`;
    },
    onClickEvent(e) {
      this.message = `You clicked: ${e.title}`;
    },
    setShowDate(d) {
      this.message = `Changing calendar view to ${d.toLocaleDateString()}`;
      this.showDate = d;
    },
    onDrop(event, date) {
      this.message = `You dropped ${event.id} on ${date.toLocaleDateString()}`;
      // Determine the delta between the old start date and the date chosen,
      // and apply that delta to both the start and end date to move the event.
      const eLength = this.dayDiff(event.startDate, date);
      const { mEvent } = event;
      mEvent.originalEvent.startDate = this.addDays(event.startDate, eLength);
      mEvent.originalEvent.endDate = this.addDays(event.endDate, eLength);
      return mEvent;
    },
    clickTestAddEvent() {
      this.events.push({
        startDate: this.newEventStartDate,
        endDate: this.newEventEndDate,
        title: this.newEventTitle,
      });
      this.message = 'You added an event!';
    },
  },
};
</script>

<style scoped>
.calendar-parent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: hidden;
  max-height: 80vh;
  background-color: white;
}
/* For long calendars, ensure each week gets sufficient height.
The body of the calendar will scroll if needed */
.cv-wrapper.period-month.periodCount-2 .cv-week,
.cv-wrapper.period-month.periodCount-3 .cv-week,
.cv-wrapper.period-year .cv-week {
  min-height: 6rem;
}
/* These styles are optional, to illustrate the flexbility of styling the
 calendar purely with CSS. */
/* Add some styling for events tagged with the "birthday" class */
.calendar .event.birthday {
  background-color: #e0f0e0;
  border-color: #d7e7d7;
}
</style>
